export const PRECISION = 3;
export const SCALE = 10 ** 3;
export const MIN_TOPUP_AMOUNT = 5;